import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NavDataService } from '@app/core/services/nav-data/nav-data.service';

@Component({
  selector: 'instructor-coach-promo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './instructor-coach-promo.component.html',
  styleUrls: ['./instructor-coach-promo.component.scss'],
})
export class InstructorCoachPromoComponent {
  // We inject the service when the modal is open, is not defined the type to avoid circular dependency.
  /**
   * Current InscuctorCoachPromoComponent service instance.
   */
  public service: any;
  constructor(private navDataService: NavDataService) {}

  /**
   * Open the course in another tab/InappBrowser.
   */
  openCourse(): void {
    this.service.close();
    this.navDataService.navigate('https://www.ikointl.com/course/kitesurf-coach-level-1', true);
  }
}
